module.exports = __webpack_public_path__ + "img/import-csv-material-hover.663c66fa.svg";